import { LitElement, html, css } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { VoyageRoute } from '../../../src/models/voyage-routing-model';
import { RouteSeriesNames } from '../../voy-timeseries-chart/src/echartUtils';
import '../../voyage-checkbox/src/voyage-checkbox';

export type RoutesVisibility = {
    [index in RouteSeriesNames]: boolean;
};

export enum ChartRouteSelectionEvents {
    ChartRouteSelectionUpdated = "chart-route-selection-updated"
};

@customElement('route-selection')
export class RouteSelection extends LitElement {

    @property({ type: Array, attribute: false }) routes: VoyageRoute[] = [];
    @property({ type: Boolean, attribute: false }) maximized: boolean = false;

    static get styles() {
        return [
            css`
                .container {
                    background: var(--neutrals-grey-10, white);
                    display: grid;
                    grid-template-columns: 1fr 1fr 1fr;
                    grid-gap: 16px;
                    box-sizing: border-box;
                    padding: 6px 16px 6px 16px;
                    width: 100%;
                }

                .container[maximized] {
                    grid-template-columns: 1fr;
                    grid-auto-flow: column;
                    align-items: center;
                    justify-items: end;
                }

                .checkbox {
                    flex: 1 0 30%;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                }

                .checkbox[maximized] {
                    flex: unset;
                }

                .filler {
                    width: 40px;
                }
                .filler[maximized] {
                    display: none;
                }
        `];
    }

    @property({attribute: false}) private _options: RoutesVisibility = {
        [RouteSeriesNames.Route1]: true,
        [RouteSeriesNames.Route2]: true,
        [RouteSeriesNames.Route3]: true,
        [RouteSeriesNames.Route4]: true,
        [RouteSeriesNames.Route5]: true,
    }
    
    render() {
        return html`
            <div class="container" ?maximized=${this.maximized}>
                ${
                    this.routes.map((route, index) => {
                        return html`
                            <span class="checkbox">
                                <voyage-checkbox .noOverflow=${true} ?disabled=${!route} .label=${this._getRouteSeriesName(index)} .checked=${route !== undefined} @input=${(e: Event) => this._optionClicked(this._getRouteSeriesName(index))}></voyage-checkbox>
                            </span>
                        `
                    })
                }

                <span class="filler" ?maximized=${!this.maximized}>
                    <!-- empty space filler -->
                </span>
            </div>
        `;
    }

    private _getRouteSeriesName(index: number) {
        switch(index) {
            case 0:
                return RouteSeriesNames.Route1;
            case 1:
                return RouteSeriesNames.Route2;
            case 2:
                return RouteSeriesNames.Route3;
            case 3:
                return RouteSeriesNames.Route4;
            case 4:
                return RouteSeriesNames.Route5;
            default:
                return RouteSeriesNames.Route1;
        }
    }

    private async _optionClicked(optionKey: keyof RoutesVisibility) {
        this._options[optionKey] = !this._options[optionKey]

        // update radio button state before dispatching event
        await new Promise((resolve) => setTimeout(resolve));
        await this.updateComplete;

        this.dispatchEvent(new CustomEvent(ChartRouteSelectionEvents.ChartRouteSelectionUpdated, 
            {
                detail: {
                    options: this._options,
                    changedValue: optionKey,
                    newValue: this._options[optionKey]
                }
            }
        ))        
    }
};
